const mapConfig = {
  center: [13.2, 101.6],
  zoom: 6,
  defaultLayer: 'OpenStreetMap.Mapnik',
}

export default mapConfig;
